const RAG_BASE_URL =
  process.env.REACT_APP_AGENTIC_RAG_URL || 'http://localhost:8080/api/v1/rag';

export const getAgenticRagUrl = () => RAG_BASE_URL;

export async function fetchAgenticRagHealth() {
  const res = await fetch(`${RAG_BASE_URL}/health`, { signal: AbortSignal.timeout(5000) });
  if (!res.ok) throw new Error(`Health check failed (${res.status})`);
  return res.json();
}

/**
 * Stream SSE events from POST /query/stream.
 * Yields { type: 'step'|'answer'|'meta'|'error', content }.
 */
export async function* streamAgenticQuery(payload, { signal } = {}) {
  const body = {
    query: payload.query,
    company: payload.company || null,
    domain: payload.domain || null,
    force_web: Boolean(payload.force_web),
    force_sql: Boolean(payload.force_sql),
    force_pdf: Boolean(payload.force_pdf),
  };

  const res = await fetch(`${RAG_BASE_URL}/query/stream`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    signal,
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Request failed (${res.status})`);
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop() || '';

    for (const line of lines) {
      if (!line.startsWith('data: ')) continue;
      const data = line.slice(6).trim();
      if (data === '[DONE]') return;
      try {
        const ev = JSON.parse(data);
        if (ev?.type && ev.content !== undefined) {
          yield ev;
        }
      } catch {
        // ignore malformed SSE chunks
      }
    }
  }
}

export async function uploadBondPdf(file, { signal } = {}) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`${RAG_BASE_URL}/pdf/upload`, {
    method: 'POST',
    body: fd,
    signal,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.detail || data.message || `Upload failed (${res.status})`);
  }
  return data;
}
